import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-6 py-12" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <div className="w-10 h-10 bg-olive text-bone flex items-center justify-center font-heading font-black">
            ETI
          </div>
          <span className="font-heading font-bold text-ink">Admin Portal</span>
        </Link>

        <div className="bg-white border border-border p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} className="text-terracotta" />
            <p className="overline text-terracotta">Restricted</p>
          </div>
          <h1 className="font-heading font-black text-3xl text-olive tracking-tight">Sign in</h1>
          <p className="text-muted_ink text-sm mt-2">Authorized admins only.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-2 h-11" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-2 h-11" />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-btn"
              className="w-full bg-olive hover:bg-olive-hover text-bone rounded-none h-12 text-base font-semibold"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>

        <Link to="/" className="block text-center mt-6 text-sm text-muted_ink hover:text-terracotta">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
